import { render, staticRenderFns } from "./DemoDatepickerInternationalization.vue?vue&type=template&id=d8f5e712&"
import script from "./DemoDatepickerInternationalization.vue?vue&type=script&lang=js&"
export * from "./DemoDatepickerInternationalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDatePicker,VRow})
